import store from '@/store';
import {  reactive  } from 'vue';
import { apiWsFake,apiWsModelData } from '@/api/api';
import i18n from '@/locales/i18n';
// import router from '@/router';
// import {  ACTIONBAR } from '@/enum/enum';


export const wsInit =  async() => {
  // const store = useStore();

  const storeState = store.state;

  let state = reactive({
    ws: null,
    url: '',

  })
  console.log('wsSite',store.state.wsSite)

  const _env = process.env.NODE_ENV;
  if(_env === 'mock'){
    getFake()
  }else if(_env === 'dev'){
    // store.commit('setWsData', 1)
  }

  state.url = `${store.state.wsSite}`;
  state.ws = new WebSocket(state.url); 
  console.log('window.WebSocket',state.ws)

  if (!window.WebSocket) {
    return console.log('瀏覽器不支援WebSocket');
  }
  state.ws.onopen = () => {
      console.log('connect success');
    };
  state.ws.onmessage = (e) => {
    console.log('window WebSocket message',e.data);
    let result = JSON.parse(e.data);
    console.log('JSON.parse',result)
    store.commit('setWsData', result)

  };
  state.ws.onclose = () => {
    console.log('ws 關閉連線')
    store.commit('setWsOffline', true)
  };


  store.watch((state) => (state.wsData), async () => { //websocket 的資料有更新的
    if(storeState.wsData['device']){
      const data = await getSsnDetail(storeState.wsData['device'])
      if(data){
        openFlashMsg(storeState.wsData, data)
        
      }
    }
  })
}



const getSsnDetail = async (id) => {
  try {
    const datas = await apiWsModelData(id);
    // console.log('ws datas',datas)
    return datas.data
  }
  catch (error) {
    return error;
  }

}


const openFlashMsg = (wsData,modelData) => {
  console.log('openFlashMsg',wsData)
  const {result} = wsData;
  let textResult = result == 0? i18n.global.t('__flash.__osdProfileApplySuccessfully') : i18n.global.t('__flash.__osdProfileApplyFail') ;  //@i18n
  let model = modelData.model ? modelData.model : ' ';
  let host = modelData.host ? modelData.host : '';
  store.commit('setFlashMsg', { data: `${model} ${host}    ${textResult}`, isShow: true })
}



const getFake = async () => {
  try {
    const datas = await apiWsFake();
    
    store.commit('setWsData', datas.result)

  }
  catch (error) {
    return error;
  }

}



// export default  {
//   setup(){
//     const store = useStore();
//     // let ws= new WebSocket('ws://localhost:8080/socket'+userid);
    
    
//     onMounted(() => {
//     }) //end: onMounted

//     const queryApiWsSite = async () => {
//       try {
//         const datas = await apiWsSite();
//         store.commit('setWsSite', datas.data);
//       }
//       catch (error) {
//         console.log('ws error',error)
//         return error;
//       }
//     }
//     const aaa = async () => {
//       console.log('ker ker',store.state.wsSite)
//     }

//     return{
//       store,
//       queryApiWsSite,
//       aaa
//     }

//   }, 
// }


// export default class SocketService {
//   static instance = null;
//   static get Instance() {
//     if (!this.instance) {
//       this.instance = new SocketService();
//     }
//     return this.instance;
//   }
  
//   // 和服务端连接的socket对象
//   ws = null;
//   // 存储回调函数
//   callBackMapping = {};
//   // 标识是否连接成功
//   connected = false;
//   // 记录重试的次数
//   sendRetryCount = 0;
//   // 重新连接尝试的次数
//   connectRetryCount = 0;
//   //  定义连接服务器的方法
//   connect() {
//     const store = useStore();
      
//       console.log('ker ker',store.state.wsSite)
//     // 连接服务器
//     if (!window.WebSocket) {
      
//       return console.log('瀏覽器不支援WebSocket');
//     }
//     let url = `wss://proart-pubsub.webpubsub.azure.com/client/hubs/W42F76283A0664B1EBCE208A18A1F310D?access_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJodHRwczovL3Byb2FydC1wdWJzdWIud2VicHVic3ViLmF6dXJlLmNvbS9jbGllbnQvaHVicy9XNDJGNzYyODNBMDY2NEIxRUJDRTIwOEExOEExRjMxMEQiLCJpYXQiOjE2NDA4MjgwNjIsImV4cCI6MTY0MDgzMTY2Mn0.hEo-aMzRoLRFk8T7jZKz5qG-7Bn-2-ks0-TXVSAYHLU`;
//     this.ws = new WebSocket(url, 'echo-protocol');
//     // success
//     this.ws.onopen = () => {
//       console.log('ws connect success');
//       this.connected = true;
//       // reset reconnect count
//       this.connectRetryCount = 0;
//     };
//     // 1.连接服务端失败
//     // 2.当连接成功之后, 服务器关闭的情况
//     this.ws.onclose = () => {
//       console.log('connect fail');
//       this.connected = false;
//       this.connectRetryCount++;
//       setTimeout(() => {
//         this.connect();
//       }, 500 * this.connectRetryCount);
//     };
//     // 得到服务端发送过来的数据
//     this.ws.onmessage = msg => {
//       console.log(msg.data, 'get data');
//     };
//   }
//   // 回调函数的注册
//   registerCallBack(socketType, callBack) {
//     this.callBackMapping[socketType] = callBack;
//   }
//   // 取消某一个回调函数
//   unRegisterCallBack(socketType) {
//     this.callBackMapping[socketType] = null;
//   }
//   // 发送数据的方法
//   send(data) {
//     // 判断此时此刻有没有连接成功
//     if (this.connected) {
//       this.sendRetryCount = 0;
//       try {
//         this.ws.send(JSON.stringify(data));
//       } catch (e) {
//         this.ws.send(data);
//       }
//     } else {
//       this.sendRetryCount++;
//       setTimeout(() => {
//         this.send(data);
//       }, this.sendRetryCount * 500);
//     }
//   }
// }
